import { i18ntrans } from 'language/i18nkey';
import { langutil } from 'language/langutil';
import { RES_ADMIN } from 'language/resi18n_admin_page';

export const useTrans = (): { tadmin: (key: RES_ADMIN | string, p?) => string } => {
  const tadmin = i18ntrans.admin;
  return { tadmin };
};
